// Verbindungsdaten zur Microsoft-Anmeldung.
//
// Die Client-ID ist KEIN Geheimnis – sie steht in jeder ausgelieferten
// Browser-App. Ein Client-Geheimnis gibt es hier bewusst nicht: Mit Nested
// App Authentication braucht die App keinen Server-Teil, der eines
// bräuchte. Damit entfällt auch dessen Ablaufdatum.

export const TENANT_ID = "c8829a13-44bc-4793-96d5-1d06c2eab6ca"; // Christliche Zeltlagerarbeit e.V.

// App-Registrierung "AC-Zeitplan" im Tenant der Zeltlagerarbeit (19.09.2026).
export const CLIENT_ID = "5e3e1ab4-9501-4c53-9794-4459baadcbf6";

// Rechte, die die App braucht. Bewusst klein halten – NAA erlaubt es,
// Rechte erst dann zu erfragen, wenn sie gebraucht werden.
export const SCOPES = {
  ich: ["User.Read"],
  // NUR LESEN: Die App schreibt nie nach Planner (entschieden 23.09.2026,
  // siehe entwurf/LIESMICH.md). Wer hier je wieder `Tasks.ReadWrite` braucht,
  // muss es ZUERST in der App-Registrierung ergänzen und die
  // Administratorzustimmung erteilen – sonst scheitert die Anmeldung für alle.
  planner: ["Tasks.Read", "User.ReadBasic.All"],
} as const;
